import { useEffect } from 'react'
import { useAppDispatch } from './useRedux'
import i18n from '@/i18n'

export function useSetLanguagePreference() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    const savedLanguage = localStorage.getItem('languagePreference')
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage)
    }
  }, [dispatch])
}
